import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowDownRight"><Path fillRule="evenodd" clipRule="evenodd" d="M5.54289 5.54289C5.93342 5.15237 6.56658 5.15237 6.95711 5.54289L17 15.5858V9C17 8.44772 17.4477 8 18 8C18.5523 8 19 8.44772 19 9V18C19 18.5523 18.5523 19 18 19H9C8.44772 19 8 18.5523 8 18C8 17.4477 8.44772 17 9 17H15.5858L5.54289 6.95711C5.15237 6.56658 5.15237 5.93342 5.54289 5.54289Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownRight;
